import * as types from '../../constants/rmg/EventActionTypes'
import produce from 'immer'
import _ from 'lodash';

const initialState = {
    events: null,
    daterange: null,
    sport: null,
    loading: false
};

const request = (state, start, selectedId) => produce(state, draft => {
    draft.sport = selectedId;
    draft.daterange = [start];
    draft.events = null;
    draft.loading = true;
});

const receive = (state, start, selectedId, data) => produce(state, draft => {
        draft.sport = selectedId;
        draft.daterange = [start];
        draft.events = data;
        draft.loading = false;
});

export default function reduce (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST:
        return request(state, action.start, action.id)
    case types.RECEIVE:
        return receive(state, action.start, action.id, action.data);
    default:
      return state
  }
}
